import { z } from 'zod';

import { jobArchitectureGenerationInfoSchema } from './job-architecture';
import { creatorSchema, jobArchitectureProfileReviewerSchema, jobProfileLegacySchema } from './job-profile';
import { versionInformationSchema } from './job-profile-versions';
import { actionsSchema, translationSchema } from './job-role-details';

export const jobLevelDetailsSchema = z
    .object({
        id: z.uuid(),
        actions: actionsSchema,
        architectureId: z.uuid(),
        creator: creatorSchema.optional(),
        externalId: z.string().optional(),
        isArchived: z.boolean(),
        jobProfile: jobProfileLegacySchema.optional(),
        parentId: z.uuid(),
        profileGenerationInfo: jobArchitectureGenerationInfoSchema.optional(),
        reviewer: jobArchitectureProfileReviewerSchema.optional(),
        title: z.string(),
        translations: translationSchema.array(),
        versionInfo: versionInformationSchema.optional(),
    })
    .transform((jobLevelDetails) => ({
        ...jobLevelDetails,
        type: 'job-level' as const,
    }));

export type JobLevelDetails = z.infer<typeof jobLevelDetailsSchema>;
